// src/services/settingsService.ts

export interface ProfileResponse {
  address?: string;
  bio?: string;
  city?: string;
  created_at?: string;
  department?: string;
  email: string;
  email_verified_at?: string;
  id: number;
  name: string;
  phone: string;
  phone_verified_at?: string;
  preferences?: string;
  profile_pic?: string;
  role: string;
  status?: string;
  surname?: string;
  updated_at?: string;
  zip_code?: string;
}
import { set } from "react-hook-form";

import api from "./api";

export async function changeEmail(email: string) {
  try {
    const response = await api.put("/users/change-email", { email });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function changePhone(phone: string) {
  try {
    const response = await api.put("/user/change-phone", { phone });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function fetchPreferences() {
  try {
    const response = await api.get("/users/preferences/fetch");
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getProfile() {
  try {
    const response = await api.get("/profile");
    console.log("Profile API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Profile API error:", error);
    throw error;
  }
}

export async function updatePreferences(preferences: any) {
  try {
    const response = await api.put("/users/preferences", preferences);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateProfile(profile: ProfileResponse) {
  try {
    const response = await api.put("/users/profile", profile);
    return response.data;
  } catch (error) {
    throw error;
  }
}

const settingsService = {
  changeEmail,
  changePhone,
  fetchPreferences,
  getProfile,
  updatePreferences,
  updateProfile,
};

export default settingsService;
